import { useMutation, useQuery } from '@tanstack/react-query';
import { RiskEngineName } from 'types/risk';
import { HealthRisksResponse } from './type';
import { executeRiskEngine, getHealthRisks, getRiskTrend } from './api';
import { QUESTIONNAIRE_CODE } from 'lib/constants';
import { useNavigate } from 'react-router-dom';
import { PATH_ROUTES } from 'routes/path';
import useRiskCheckerStore from 'store/risk-checker';
import { useQuestionnaireStore } from 'store/questionnaire';

export const HYPERTENSION_RISK = 'hypertension-risk';
export const FETCH_HEALTH_RISK = 'fetch-health-risk';
export const EXECUTE_RISK_ENGINE = 'execute-risk-engine';

export const useGetRiskTrends = () => {
  return useQuery({
    queryKey: ['risk-trends'],
    queryFn: () => getRiskTrend(),
  });
};

interface FetchHealthRiskVariables {
  risk_type: RiskEngineName;
}

export const useExecuteRiskEngine = () => {
  const setViewRiskDetails = useRiskCheckerStore(
    (store) => store.setViewRiskDetails
  );

  return useMutation<HealthRisksResponse, unknown, FetchHealthRiskVariables>({
    mutationKey: [EXECUTE_RISK_ENGINE],
    mutationFn: executeRiskEngine,
    onSuccess: (riskEngineDetails) => {
      if (riskEngineDetails?.screen_name === 'view_risk_score') {
        console.log(
          '🚀 ~ useExecuteRiskEngine ~ riskEngineDetails:',
          riskEngineDetails
        );
        setViewRiskDetails(riskEngineDetails?.data);
      }
    },
  });
};

export const useGetRiskDetail = () => {
  const navigate = useNavigate();
  const { mutateAsync: executeRiskEngineMutation } = useExecuteRiskEngine();
  const setQuestionData = useQuestionnaireStore(
    (store) => store.setQuestionData
  );

  return useMutation<HealthRisksResponse, unknown, FetchHealthRiskVariables>({
    mutationKey: [FETCH_HEALTH_RISK],
    mutationFn: getHealthRisks,
    onSuccess: async (riskDetails, variable) => {
      console.log('🚀 ~ useGetRiskDetail ~ riskDetails:', riskDetails);
      const { risk_type } = variable;

      if (riskDetails?.screen_name === 'questionnaire') {
        if (riskDetails?.data?.code === QUESTIONNAIRE_CODE.FACESCAN) {
          // useQuestionnaireStore.setState({
          //   questionnaireData: riskDetails?.data,
          // });
          // navigationRef.reset({
          //   index: 1,
          //   routes: [
          //     {
          //       name: ROUTES.MAIN.BOTTOM_TABS,
          //       params: { screen: ROUTES.MAIN.HOME },
          //     },
          //     { name: ROUTES.MAIN.HEALTH_RISK_REPORT },
          //     { name: ROUTES.MAIN.QUESTIONNAIRE.FACESCAN },
          //   ],
          // });
          navigate(PATH_ROUTES.RISK_ANALYSIS_SCAN, {
            state: riskDetails?.data,
          });
        }
        if (riskDetails?.data) {
          const nextQuestion = riskDetails?.data;
          console.log('🚀 ~ useGetRiskDetail ~ nextQuestion:', nextQuestion);

          if (nextQuestion?.code === 'facescan') {
            return navigate(PATH_ROUTES.RISK_ANALYSIS_SCAN, {
              state: riskDetails?.data,
            });
          }

          setQuestionData(nextQuestion);
          navigate(PATH_ROUTES.RISK_ANALYSIS_QUESTIONNAIRE);
        }
      }

      if (riskDetails?.screen_name === 'generate_risk_score') {
        await executeRiskEngineMutation({ risk_type });
        navigate(PATH_ROUTES.RISK_ANALYSIS_DETAIL);
      }
    },
  });
};
